// extracted by mini-css-extract-plugin
export var quillEditor = "_ow-1";
export var variable = "_ow-0";